import { useEffect } from 'react';

import { showBanner } from './admob';
import { useAds } from './AdsProvider';
import { isNative } from './config';

/**
 * Keeps the phone app's AdMob banner up and tells the page how tall it is (as the CSS variable
 * `--banner-height`), so the layout can stop above it. Draws nothing itself.
 */
export const NativeBanner = (): null => {
    const { adsEnabled } = useAds();
    useEffect(() => {
        if (!isNative() || !adsEnabled) return;
        let remove: (() => void) | undefined;
        let cancelled = false;
        void showBanner((px) =>
            document.documentElement.style.setProperty(
                '--banner-height',
                `${px}px`
            )
        ).then((stop) => {
            if (cancelled) stop();
            else remove = stop;
        });
        return () => {
            cancelled = true;
            remove?.();
        };
    }, [adsEnabled]);
    return null;
};
